import TopProjects from "../components/home/TopProjects";
import BannerCarousal from "./../components/common/BannerCarousal";
import PatrocinosCards from "./../components/common/PatrocinosCards";
import SponsorBanner from "../components/common/SponserBanner";

const Home = () => {
  return (
    <>
      <div className="lg:px-40">
        <BannerCarousal />
        <TopProjects />
        <PatrocinosCards />
        <SponsorBanner />
      </div>
    </>
  );
};

export default Home;
